<div
  class="search-input"
  [ngStyle]="{ width: isFullWidth ? '' : defaultWidth + 'px', 'max-width': isFullWidth ? '' : defaultWidth + 'px' }"
  [ngClass]="{ 'full-width': isFullWidth }"
>
  <form class="search-input__form" autocomplete="off" (submit)="onSubmit()">
    <div class="form-group flex-grow-1">
      <app-control-wrapper classGroup="m-0" [control]="formControl" [isShowHelper]="false">
        <input
          [id]="id"
          [name]="name"
          control-wrapper
          type="text"
          [formControl]="formControl"
          class="form-control"
          [placeholder]="!!placeholder ? (placeholder | translate) : ('BUTTON.SEARCH' | translate)"
          [mask]="mask"
          [appMaskErrorTooltip]="!!maskErrorTooltip ? maskErrorTooltip : 'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [dropSpecialCharacters]="dropSpecialCharacters"
          [patterns]="patterns"
          (keydown)="onInputKeyPress($event)"
        />
      </app-control-wrapper>
      <div
        *ngIf="showIcon"
        class="search-input__input-icon"
        [ngClass]="{ 'no-cursor': !isIconSubmittable }"
        (click)="!!isIconSubmittable && onSubmit()"
      >
        <img [src]="!!iconSrc ? iconSrc : '/assets/icons/icon_search.svg'" alt="search" />
      </div>
    </div>
    <div
      *ngIf="!!isShowClearButton"
      class="search-input__clear-button"
      nz-tooltip
      nzTooltipPlacement="top"
      [nzTooltipTitle]="!!clearButtonTooltip ? (clearButtonTooltip | translate) : ('BUTTON.CLEAR' | translate)"
      (click)="onClear()"
    >
      <img class="search-input__clear-button__icon" [src]="!!clearButtonIconSrc ? clearButtonIconSrc : '/assets/icons/icon_trash.svg'" />
    </div>
  </form>
</div>
